import {FaPlus, FaTrash} from "react-icons/fa";
import React from "react";

const BottomHoleDescriptionsTable = (setSelectedRow, setFormModal, setDeleteModal) => {
    return [
        {
            Header: 'Description',
            accessor: 'description',
        },
        {
            id: 'actions',
            Header: () => {
                return (
                    <FaPlus
                        color='#22af47'
                        size={18}
                        title="Create"
                        onClick={() => {
                            setSelectedRow({});
                            setFormModal({isOpen: true, action: 'create'});
                        }}
                    />
                )
            },
            Cell: (cell) => {
                const row = cell.row.original;
                return (
                    <>
                        {/* TO DO We need to update field bottom hole records at the same time*/}
                        {/*<FaPencilAlt*/}
                        {/*    className="actions"*/}
                        {/*    title="Edit"*/}
                        {/*    onClick={() => {*/}
                        {/*        setSelectedRow(row);*/}
                        {/*        setFormModal({isOpen: true, action: 'edit'});*/}
                        {/*    }}*/}
                        {/*/>*/}
                        {' '}
                        <FaTrash
                            className="actions"
                            title="Delete"
                            onClick={() => {
                                const msg = <p>Are you sure you want to delete bottom hole description <b>{row.description}</b></p>;
                                setSelectedRow(row);
                                setDeleteModal({
                                    message: msg,
                                    isOpen: true,
                                })
                            }}
                        />
                    </>
                )
            }
        }
    ];
}

export default BottomHoleDescriptionsTable;



